export enum TimeReportStatus {
  Blank = "Blank",
  Draft = "Draft",
  SubmittedByConsultant = "SubmittedByConsultant",
  ConsultantPaymentProcessed = "ConsultantPaymentProcessed",
  SentToConsultant = "SentToConsultant",
  SentToCustomer = "SentToCustomer",
  ApprovedByCustomer = "ApprovedByCustomer",
  RejectedByCustomer = "RejectedByCustomer",
  Canceled = "Canceled",
  Disabled = "Disabled",
  // BookingKitStatusType
  SentToHBA = "SentToHBA",
  RejectByHBA = "RejectByHBA",
  SentToOC = "SentToOC",
  RejectByOC = "RejectByOC",
  RejectByFinance = "RejectByFinance",
  SentToFinance = "SentToFinance"
}
